import React from "react";
import { AssignmentPinsContext, AssignentPinsProvderValue } from "components/Assignment/AssignmentPinsProvider";
import { useContext } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const AssignmentPinsSelection = () => {
  const pinsContext = useContext<AssignentPinsProvderValue>(AssignmentPinsContext);

  // TODO: show example pins?

  return (
    <div className="user-preference-selection-control">
      <RadioGroup
        name="theme"
        value={pinsContext?.current?.code}
        onChange={e => pinsContext?.change(e.target.value)}>
          {pinsContext?.options?.map(t => (
            <FormControlLabel className="theme-choice" value={t.code} control={<Radio />} label={<span className="theme-name">{t.name}</span>} />
          ))}
      </RadioGroup>
    </div>
  );
};

export default AssignmentPinsSelection;